<template>
  <div class="poster-wrap">
    <el-dialog
      title="修改海报"
      width="1200px"
      :visible="updatePosterDialog"
      @close="closeDialog"
    >
      <div class="creat-poster">
        <div class="posback">
          <img :src="position.basicUrl" class="backimg" />
          <div
            class="qrimg"
            :style="{
              width: position.qrCodeWidth + 'px',
              left: position.qrCodeX + 'px',
              top: position.qrCodeY + 'px',
              height: position.qrCodeHeight + 'px'
            }"
          ></div>
        </div>
        <div class="qr-setting">
          <p>二维码位置设置：</p>
          <el-form ref="forms" label-width="50px">
            <el-form-item label="X：" prop="imageUrl">
              <el-input-number v-model="position.qrCodeX"></el-input-number>
            </el-form-item>
            <el-form-item label="Y：" prop="imageUrl">
              <el-input-number v-model="position.qrCodeY"></el-input-number>
            </el-form-item>
            <el-form-item label="宽：" prop="imageUrl">
              <el-input-number v-model="position.qrCodeWidth"></el-input-number>
            </el-form-item>
            <el-form-item label="高：" prop="imageUrl">
              <el-input-number
                v-model="position.qrCodeHeight"
              ></el-input-number>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="closeDialog">取消</el-button>
            <el-button type="primary" @click="handleSave()">保存</el-button>
          </span>
        </div>
      </div>
      <div class="uplo">
        <el-form ref="form" label-width="130px">
          <el-form-item label="重新上传背景：">
            <upload @uploaded="imgBack"></upload>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { SlightlySmilingFace } from '@icon-park/vue';
import Upload from 'components/upload';
import { mapActions, mapState, mapMutations } from 'vuex';

export default {
  data() {
    return {
      posterType: 1,
      data1:'',
      pager: {
        page: 1,
        size: 10
      },
      position: {
        basicUrl: this.onePoster.basicUrl,
        qrCodeY: this.onePoster.qrCodeY,
        qrCodeX: this.onePoster.qrCodeX,
        qrCodeWidth: this.onePoster.qrCodeWidth,
        qrCodeHeight: this.onePoster.qrCodeHeight
      }
    };
  },
  props: ['onePoster','baseDomain'],
  computed: {
    ...mapState('poster', ['updatePosterDialog'])
  },
  methods: {
    ...mapActions('poster', ['updatePoster', 'list']),
    ...mapMutations('poster', ['setupdatePosterDialog']),
    imgBack(data) {
      this.data1=data
      this.position.basicUrl =data;
    },
    closeDialog() {
      this.setupdatePosterDialog(false);
    },
    handleSave() {
      this.updatePoster({ posterType: 1, ...this.position,basicUrl:this.data1 })
        .then(res => {
          this.$message.success('操作成功！');
          this.list({ posterType: this.posterType, ...this.pager });
          // this.$emit('refresh');
        })
        .finally(() => {
          this.setupdatePosterDialog(false);
        });
    }
  },
  watch: {
    onePoster(val, oldVal) {
      if (val !== oldVal) {
        this.position = { ...val };
      }
    }
  },
  components: {
    Upload
  },
  mounted() {}
};
</script>
<style lang="less">
.uplo {
  margin-top: 20px;
}
.creat-poster {
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  .posback {
    position: relative;
    .qrimg {
      position: absolute;
      background: black;
    }
  }
}
.qr-setting {
  border: 1px solid #ddd;
  padding: 50px;
  margin-left: 30px;
  p {
    text-align: center;
  }
  .dialog-footer {
    display: flex;
    justify-content: center;
    .el-button {
      width: 100%;
    }
  }
}
</style>
